import Player from 'video.js/dist/types/player';

export const getPlayerWatchTime = (player: Player | null) => {
    if (!player) {
        return {currentTime: 0, duration: 0, progressPercentage: 0};
    }

    const currentTime = player.currentTime() ?? 0;
    const duration = player.duration() ?? 0;
    const progressPercentage = Math.floor((currentTime / duration) * 100);
    return {currentTime, duration, progressPercentage};
};
